import React, {useEffect, useState} from "react";
import Container from "../components/@FreeModel/Container/Container";
import {Button, Text, Title} from "../components/@FreeModel";
import Footer from "../components/general/Footer";
import {useParams} from "react-router-dom";
import {gql, queryApplication} from "../db/model";
import {useDispatch, useSelector} from "react-redux";
import {selectApplication} from "../db/selectors";

const IncorrectEmail = (): React.ReactElement => {
  const {applicationID} = useParams()
  const dispatch = useDispatch()
  const application = useSelector(selectApplication)
  const [loading, setLoading] = useState(true)
  const location = `/login?prompt=login&redirect=/contractors/${applicationID}/steps`

  useEffect(() => {
    if (applicationID && loading) {
      // @ts-ignore
      dispatch(gql({
        query: queryApplication,
        variables: {
          id: applicationID,
        },
        onSuccess: (newState) => setLoading(false),
      }))
    }

  }, [dispatch, applicationID, loading])

  if (loading) {
    return <div></div>
  }

  return <Container className="landing-page">
    <Title size="xl-xxl" weight="semibold" lineHeight="lg">Incorrect email address</Title>

    <br/>

    <Text>
      The email address specified in the invite is <strong>{application.email ?? 'not set'}</strong>
    </Text>

    <br/>

    <Text>
      Sign in with that email address.
    </Text>

    <br/>
    <br/>

    <Button onClick={() => document.location = location}>Sign In</Button>

    <br/>
    <br/>

    <Footer/>

  </Container>
}

export default IncorrectEmail;
